import Vue from 'vue'
const requireComponent = require.context('@c:global', true, /index\.vue$/)
requireComponent.keys().forEach(fileName => {
	const componentConfig = requireComponent(fileName)
	Vue.component(componentConfig.default.name || componentConfig.name, componentConfig.default || componentConfig)
})
